import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { DevicesOnline } from '../../types'

/**
 * Large Vision Devices Online reducer
 */
const largeVisionDevicesOnline = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_DEVICES_ONLINE,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DEVICES_ONLINE.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DEVICES_ONLINE.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_DEVICES_ONLINE.failure,
    },
    transform: (state, { payload }): DevicesOnline => {
        const { online, offline }: DevicesOnline = payload || {}
        return { online, offline }
    },
})

export default largeVisionDevicesOnline
